import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { autoFinalizeAuctions } from "./web3";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  const finalize = async () => {
    await autoFinalizeAuctions()
  }
  useEffect(() => {
    finalize()
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
